import { Close } from '@carbon/icons-react';
import { IconButton } from '@mui/joy';
import { styled } from '@mui/joy/styles';
import { UrlObject } from 'url';

export enum ButtonCloseVariants {
  DEFAULT,
  TOAST,
}

export interface ButtonCloseProps {
  href?: string | UrlObject;
  onClick?: () => void;
  variant?: ButtonCloseVariants;
}

const ButtonClose = ({ variant, ...rest }: ButtonCloseProps): JSX.Element =>
  variant === ButtonCloseVariants.DEFAULT ? (
    <CircleButton {...rest}>
      <Close size={24} />
    </CircleButton>
  ) : (
    <InvisibleButton {...rest}>
      <Close size={24} />
    </InvisibleButton>
  );

export default ButtonClose;

const CircleButton = styled(IconButton)`
  border-radius: 32px;
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.vars.palette.beige};
  color: ${({ theme }) => theme.vars.palette.grey3};

  &:hover {
    background-color: ${({ theme }) => theme.vars.palette.grey2};
  }
`;

const InvisibleButton = styled('div')`
  background-color: transparent;
  color: white;
  cursor: pointer;
`;
